export const money = (n, currency = "DOP") => {
  const locale = currency === "USD" ? "en-US" : "es-DO";
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(Number(n) || 0);
};

export const moneyExplicit = (n, currency = "DOP") => {
  const symbol = currency === "USD" ? "US$" : "RD$";
  return `${symbol} ${(Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const dateFmt = (iso, lang = "es") => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString(lang === "es" ? "es-ES" : "en-US", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const dateTimeFmt = (iso, lang = "es") => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString(lang === "es" ? "es-ES" : "en-US", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};
